import { SmeProfile } from './SmePages';

export default SmeProfile;
